import React from 'react'
import propTypes from 'prop-types'
import {isEqual} from 'lodash'
import {getTextNeedingTranslation, getTranslations} from 'helpers/language'

class Translator extends React.Component {

  componentDidMount() {
    this.checkTranslations()
  }

  componentDidUpdate(prevProps) {
    const {targetLanguage, text} = this.props
    const {targetLanguage: prevTargetLanguage, text: prevText} = prevProps

    if (!isEqual(targetLanguage, prevTargetLanguage) ||
        !isEqual(text, prevText)) {

      this.checkTranslations()
    }
  }

  checkTranslations = () => {
    const {user, text, languageMap, targetLanguage, onTranslate} = this.props

    const textToTranslate = getTextNeedingTranslation(user, text, languageMap, targetLanguage)
    textToTranslate.forEach(onTranslate)
  }

  render() {
    const {user, text, languageMap, targetLanguage, dataTokens, showOriginal, onRender} = this.props

    const translations = getTranslations(user, text, languageMap, dataTokens, targetLanguage, showOriginal)
    return onRender(translations)
  }
}

Translator.propTypes = {
  onRender: propTypes.func.isRequired,
  text: propTypes.object.isRequired,
  dataTokens: propTypes.object,
  showOriginal: propTypes.bool,

  // Provided by connect
  user: propTypes.object.isRequired,
  languageMap: propTypes.object,
  targetLanguage: propTypes.string.isRequired,
  onTranslate: propTypes.func.isRequired,
}

export default Translator
